import { createAction } from 'deox';

/**
 * Dispatched when a page view event is triggered.
 */
var viewPage = createAction('VIEW_PAGE', function (resolve) { return function (pageName) { return resolve({ pageName: pageName }); }; });
/**
 * Dispatched when the Adobe tracking ID is available.
 */
var loadAdobeTrackingId = createAction('LOAD_ADOBE_TRACKING_ID', function (resolve) { return function (trackingId) {
    return resolve({
        adobeTrackingId: trackingId,
    });
}; });
/**
 * Dispatched when the application is submitted.
 */
var submitApplication = createAction('SUBMIT_APPLICATION');
var ApplicationResultType;
(function (ApplicationResultType) {
    ApplicationResultType["Approved"] = "APPROVED";
    ApplicationResultType["Pending"] = "PENDING";
    ApplicationResultType["Declined"] = "DECLINED";
    ApplicationResultType["AccountExists"] = "ACCOUNT_EXISTS";
    ApplicationResultType["Error"] = "ERROR";
})(ApplicationResultType || (ApplicationResultType = {}));
var PrescreenApplicationResultType;
(function (PrescreenApplicationResultType) {
    PrescreenApplicationResultType["Approved"] = "APPROVED";
    PrescreenApplicationResultType["Pending"] = "PENDING";
    PrescreenApplicationResultType["Declined"] = "DECLINED";
    PrescreenApplicationResultType["AccountExists"] = "ACCOUNT_EXISTS";
    PrescreenApplicationResultType["Error"] = "ERROR";
})(PrescreenApplicationResultType || (PrescreenApplicationResultType = {}));
var OfferResponseType;
(function (OfferResponseType) {
    OfferResponseType["Yes"] = "YES";
    OfferResponseType["No"] = "NO";
    OfferResponseType["NotMe"] = "NOT_ME";
    OfferResponseType["Abandoned"] = "ABANDONED";
    OfferResponseType["PrescreenNo"] = "PRESCREEN_NO";
})(OfferResponseType || (OfferResponseType = {}));
var PrequalApplicationResultType;
(function (PrequalApplicationResultType) {
    PrequalApplicationResultType["Approved"] = "APPROVED";
    PrequalApplicationResultType["Pending"] = "PENDING";
    PrequalApplicationResultType["Declined"] = "DECLINED";
    PrequalApplicationResultType["AccountExists"] = "ACCOUNT_EXISTS";
    PrequalApplicationResultType["Error"] = "ERROR";
})(PrequalApplicationResultType || (PrequalApplicationResultType = {}));
/**
 * Dispatched the credit application result is received.
 */
var receiveApplicationResult = createAction('RECEIVE_APPLICATION_RESULT', function (resolve) { return function (result) { return resolve(result); }; });
/**
 * Dispatched when application timeout before submitting.
 */
var applicationTimeout = createAction('TIMEOUT_APPLICATION');
/**
 * Dispatched when the Digital Shopping Pass page times out.
 */
var dspTimeout = createAction('TIMEOUT_DSP');
/**
 * Dispatched when the user click on the the Add To Wallet button.
 */
var addToWallet = createAction('ADD_TO_WALLET');
/**
 * Dispatched when the prescreen Application is submitted.
 */
var submitPrescreenApplication = createAction('SUBMIT_PRESCREEN_APPLICATION');
/**
 * Dispatched the prescreen Application result is received.
 */
var receivePrescreenApplicationResult = createAction('RECEIVE_PRESCREEN_APPLICATION_RESULT', function (resolve) { return function (result) { return resolve(result); }; });
/**
 * dispatched when an offer is made.
 */
var offerResponse = createAction('OFFER_RESPONSE', function (resolve) { return function (result) { return resolve(result); }; });
/**
 *  dispatched when the application is complete.
 */
var applicationComplete = createAction('APPLICATION_COMPLETED');
/**
 *  dispatched when the height of the tracked dom element is changed.
 */
var heightChanged = createAction('HEIGHT_CHANGED', function (resolve) { return function (height) { return resolve(height); }; });
/**
 * dispatched when the client cancels the application.
 */
var cancelApplication = createAction('CANCEL_APPLICATION');
/**
 * dispatched when the client click on the button to save the temporary pass
 * to their mobile device.
 */
var textToRecover = createAction('textToRecover');
/**
 * dispatched when the client clicks on the button to accept the prequalification offer.
 */
var acceptPrequalOffer = createAction('ACCEPT_PREQUAL_OFFER');
/**
 * dispatched when the client clicks on the button to decline the prequalification offer.
 */
var declinePrequalOffer = createAction('DECLINE_PREQUAL_OFFER');
/**
 * dispatched when the client clicks on the button to text the prequalification offer.
 */
var textPrequalOffer = createAction('TEXT_PREQUAL_OFFER');
/**
 * Dispatched when the prequalification application is submitted.
 */
var submitPrequalApplication = createAction('SUBMIT_PREQUAL_APPLICATION');
/**
 * Dispatched the prequalification application result is received.
 */
var receivePrequalApplicationResult = createAction('RECEIVE_PREQUAL_APPLICATION_RESULT', function (resolve) { return function (result) { return resolve(result); }; });
/* Dispatched when we receive an existing account that was not from an
 * application/acceptance request */
var receiveAccountExists = createAction('RECEIVE_ACCOUNT_EXISTS', function (resolve) { return function (result) { return resolve(result); }; });
/**
 * Dispatched when a reward is selected.
 */
var rewardsSelected = createAction('REWARDS_SELECTED', function (resolve) { return function (certificateNumbers) {
    return resolve({
        certificateNumbers: certificateNumbers,
    });
}; });

export { ApplicationResultType, OfferResponseType, PrequalApplicationResultType, PrescreenApplicationResultType, acceptPrequalOffer, addToWallet, applicationComplete, applicationTimeout, cancelApplication, declinePrequalOffer, dspTimeout, heightChanged, loadAdobeTrackingId, offerResponse, receiveAccountExists, receiveApplicationResult, receivePrequalApplicationResult, receivePrescreenApplicationResult, rewardsSelected, submitApplication, submitPrequalApplication, submitPrescreenApplication, textPrequalOffer, textToRecover, viewPage };
